import { render, staticRenderFns } from "./ProfileOverview1.vue?vue&type=template&id=1b496da2&"
import script from "./ProfileOverview1.vue?vue&type=script&lang=js&"
export * from "./ProfileOverview1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports